"use client";

import { c as _c } from "react/compiler-runtime";
import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { getGalleries } from "../api";
import type { GalleriesApiItem, GalleriesApiResponse, GalleriesQueryParams } from "../types";
function extractGalleries(response?: GalleriesApiResponse): GalleriesApiItem[] {
  if (!response) return [];
  if (Array.isArray(response.galleries)) return response.galleries;
  // fallback for possible nested data just in case
  if (Array.isArray((response as any).data?.galleries)) return (response as any).data.galleries;
  return [];
}
export function useGalleries(t0, options) {
  const $ = _c(14);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const params = t1;
  let t2;
  let t3;
  if ($[2] !== params) {
    t2 = ["galleries", params];
    t3 = () => getGalleries(params);
    $[2] = params;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  const t4 = options?.initialData;
  let t5;
  if ($[5] !== t2 || $[6] !== t3 || $[7] !== t4) {
    t5 = {
      queryKey: t2,
      queryFn: t3,
      staleTime: 60000,
      gcTime: 300000,
      retry: 1,
      initialData: t4
    };
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const query = useQuery(t5);
  let t6;
  if ($[9] !== query.data) {
    t6 = extractGalleries(query.data);
    $[9] = query.data;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const galleries = t6;
  let t7;
  if ($[11] !== galleries || $[12] !== query) {
    t7 = {
      ...query,
      galleries
    };
    $[11] = galleries;
    $[12] = query;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
}